import { type BaseRecommendationTemplate } from '../recommendationTemplate';
import { PrevisitFormFieldWithConfig } from './formField';

export enum Status {
  Created = 'CREATED',
  Started = 'STARTED',
  Completed = 'COMPLETED',
}

export interface PrevisitForm {
  id: string;
  displayName: string;
  fields: PrevisitFormFieldWithConfig[];
  hideWhenCompleted: boolean;
  name: string;
  previsitFormTemplateId: string;
  previsitFormSetId: string;
  status: Status;
  score: number | null;
  scores: Record<string, number> | null;
  isReviewable: boolean | null;
  labels: string[] | null;
  isRecommendationForm?: boolean;
  recommendation?: BaseRecommendationTemplate['localizations'];
}

export const DEFAULT_SCORE_TYPE = 'default';
